export default __webpack_public_path__ + "static/media/home2L.42561a50.webp";